import { BASE_URL } from '../../../constants/endpoints';

export const getFetchBillsAPIURL = (customerId: string, accountExternalId: string) => `${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill`;

export const BILLS_PAGE_SIZE = 15;

export const BILLS_STATUSES = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  CANCELED: 'CANCELED',
  AWAITING_DETAILS: 'AWAITING_DETAILS',
};

export const ACCEPTED_BILL_TYPES = ['image/jpeg', 'image/png', '.pdf'];
